import { Guid } from "@/types";

export interface IGetProfitCenterDto {
    id: Guid
    code: string
    description: string
}

export interface ICreateProfitCenterDto {
    code: string
    description: string
}

export default class ProfitCenter {
    id: Guid
    code: string
    description: string

    constructor({ id, code, description }: IGetProfitCenterDto) {
        this.id = id
        this.code = code
        this.description = description
    }
}
